import { render } from "./ModelsBody.vue?vue&type=template&id=c1507778"
import script from "./ModelsBody.vue?vue&type=script&lang=js"
export * from "./ModelsBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__